import { View } from "extensions/marionette";
import moment from "moment";
import $ from "jquery";

import { nextTick } from "common/utils";
import { makeMnErrorView } from "common/components/error";
import { ApiErrorFetchingData, ErrorFetchingReports } from "common/helpers/errors";

import { pazienHistory } from "common/components/pazienHistory";

import { ReportsCollection } from "../reportsCollection";

import { ReportsList } from "../reportsList";
import reportsPaneTemplate from "./reportsPane.jst";

import "./reportsPane.scss";

const RecentReports = ReportsList.extend({
    viewComparator: (view) => {
        const viewed = view.model.get("viewed");
        
        if (viewed === null) {
            return 0;
        }
        
        return -moment.utc(view.model.get("viewed"));
    },
    viewFilter: (model, index) => index < 5
});

const AllSavedReports = ReportsList.extend({
    viewComparator: (view) => view.model.get("name")
});

export const ReportsPane = View.extend({
    className: "reportsPane side-pane",
    template: reportsPaneTemplate,
    regions: {
        recentList: ".recent-reports .list",
        allList: ".saved-reports .list"
    },
    
    events: {
        "click .open-reports-page-icon": function() {
            this.hide();
            pazienHistory.navigateWithParams("reports/saved_reports", {
                trigger: true
            });
        },
        
        "click .close-reports-pane-icon": "hide"
    },
    
    childViewEvents: {
        "action:open": function({ model }) {
            this.hide();
            const type = model.get("type");
    
            if (type === "comparison") {
                pazienHistory.navigateWithParams(`reports/comparison/${model.id}`, {
                    trigger: true
                });
            } else if (type === "benchmarks") {
                pazienHistory.navigateWithParams(`reports/benchmarks/${model.id}`, {
                    trigger: true
                });
            } else {
                pazienHistory.navigateWithParams(`reports/${model.get("section_id")}/${model.id}`, {
                    trigger: true
                });
            }
        }
    },
    
    hide() {
        this.el.classList.add("behind-page");
        window.setTimeout(() => this.destroy(), 500);
    },
    
    bindClickOutside() {
        nextTick(() => {
            $(document).off(`click.${this.cid}`).on(`click.${this.cid}`, (e) => {
                if (!this.el.contains(e.target) && e.target.closest("body") !== null) {
                    this.hide();
                }
            });
        });
    },
    
    unbindClickOutside() {
        $(document).off(`click.${this.cid}`);
    },
    
    onRender() {
        const reports = new ReportsCollection();
        reports.fetch().then(() => {
            this.showChildView("recentList", new RecentReports({
                collection: reports
            }));
            this.showChildView("allList", new AllSavedReports({
                collection: reports
            }));
        }).catch((error) => {
            if (this.isDestroyed()) return;
            const captureInSentry = !(error instanceof ApiErrorFetchingData);
    
            this.showChildView("recentList", makeMnErrorView(new ErrorFetchingReports({
                message: "Error fetching saved views",
                hideDetails: true,
                originalError: error
            }), true, captureInSentry));
        });
        
        this.bindClickOutside();
    },
    
    onBeforeDestroy() {
        this.unbindClickOutside();
    }
});
